<template>
  <div class="group-checkbox">
    <template v-for="(question,index) in questions">
      <div
        v-if="question.type!=='input'"
        :key="index"
        class="question"
      >
        <div class="title">
          <span class="q-id">Q{{ index+1 }}</span>
          {{ question.title }}
        </div>
        <div class="options">
          <div
            v-for="option in question.options"
            :key="option.id"
            class="option"
            @click="select(option.id)"
          >
            <i
              :class="['fa','fa-check-square',{'selected':selected.indexOf(option.id)>=0}]"
              aria-hidden="true"
            ></i>
            {{ option.text }}
          </div>
        </div>
      </div>
    </template>

  </div>
</template>
<script>
export default {
  props: {
    questions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    activeQuestion() {
      return this.$store.state.survey.activeQuestion;
    },
    selected: {
      get: function() {
        return this.activeQuestion.setting.visibility.visible.options;
      },
      set: function(val) {
        this.activeQuestion.setting.visibility.visible.options = val;
      }
    }
  },
  methods: {
    select(id) {
      let temp = this.selected;
      let index = temp.indexOf(id);
      if (index >= 0) {
        temp.splice(index, 1);
      } else {
        temp.push(id);
      }
      this.selected = temp;
    }
  },
  components: {}
};
</script>
<style lang="less" scoped>
.question {
  font-size: 15px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 0.5px solid #f3f5f6;

  .title {
    line-height: 200%;

    .q-id {
      background-color: #495165;
      border-radius: 2px;
      font-size: 12px;
      padding: 3px;
      color: white;
    }
  }

  .options {
    margin-left: 10px;

    .option {
      line-height: 200%;
      cursor: pointer;

      .fa {
        color: lightgray;
        font-size: 16px;
      }

      .fa.selected {
        color: green;
      }
    }
  }
}
</style>
